import React, { useEffect, useRef, useState } from "react";
import { PawPrint, Star, ChevronLeft, ChevronRight } from "lucide-react";
import Reveal from "../Reveal";

const reviews = [
  { name: "Rachel Alvarez", role: "Creative Lead", img: "2-1.jpg" },
  { name: "Thomas Reed", role: "IT Manager", img: "1-1.jpg" },
  { name: "Emily Chan", role: "Marketing Director", img: "10-1.jpg" },
  { name: "Rachel Alvarez", role: "Creative Lead", img: "2-1.jpg" },
  { name: "Thomas Reed", role: "IT Manager", img: "1-1.jpg" },
  { name: "Emily Chan", role: "Marketing Director", img: "10-1.jpg" },
];

const QUOTE =
  '"Professionalism at its best. The team listened carefully and brought our vision to life with precision. Highly recommended for any creative project."';

const CountUp = ({ target = 4.7 }) => {
  const [val, setVal] = useState(0);
  const ref = useRef(null);
  useEffect(() => {
    const node = ref.current;
    if (!node) return;
    const obs = new IntersectionObserver((es) => {
      es.forEach((e) => {
        if (e.isIntersecting) {
          const start = performance.now();
          const dur = 1600;
          const tick = (now) => {
            const p = Math.min((now - start) / dur, 1);
            setVal(+(target * p).toFixed(1));
            if (p < 1) requestAnimationFrame(tick);
          };
          requestAnimationFrame(tick);
          obs.unobserve(node);
        }
      });
    }, { threshold: 0.5 });
    obs.observe(node);
    return () => obs.disconnect();
  }, [target]);
  return <span ref={ref}>{val.toFixed(1)}</span>;
};

const Testimonials = () => {
  const trackRef = useRef(null);

  const scroll = (dir) => {
    const el = trackRef.current;
    if (!el) return;
    el.scrollBy({ left: dir * (el.clientWidth * 0.85), behavior: "smooth" });
  };

  return (
    <section className="mx-auto max-w-[1290px] px-5 py-20 md:py-28">
      <div className="grid items-center gap-8 lg:grid-cols-[1fr_auto]">
        <div>
          <Reveal animation="rubberBand">
            <span className="inline-flex items-center gap-2 font-display text-[15px] font-semibold text-pawelle-primary">
              <PawPrint className="h-5 w-5" /> Testimonial
            </span>
          </Reveal>
          <Reveal animation="fadeInUp" delay={100}>
            <h2 className="mt-4 max-w-xl font-display text-[30px] font-bold leading-tight text-pawelle-ink md:text-[38px]">
              Customer Experiences That Inspire Confidence
            </h2>
          </Reveal>
        </div>

        <Reveal animation="fadeInRight" className="flex items-center gap-6">
          <div className="text-center">
            <div className="font-display text-[40px] font-bold leading-none text-pawelle-ink">
              <CountUp target={4.7} />
            </div>
            <div className="mt-1.5 flex justify-center gap-1">
              {[0, 1, 2, 3, 4].map((i) => (
                <Star key={i} className={`h-4 w-4 ${i < 4 ? "fill-pawelle-orange text-pawelle-orange" : "fill-pawelle-ink/15 text-pawelle-ink/15"}`} />
              ))}
            </div>
            <p className="mt-1.5 font-body text-[13px] text-pawelle-body">Based on 10 reviews</p>
          </div>
          <div className="flex flex-col gap-2">
            <a href="#" className="rounded-full bg-pawelle-primary px-5 py-2.5 text-center font-display text-[14px] text-white transition hover:bg-pawelle-primary-dark">View all reviews</a>
            <a href="#" className="rounded-full border-2 border-pawelle-primary px-5 py-2.5 text-center font-display text-[14px] text-pawelle-primary transition hover:bg-pawelle-primary hover:text-white">Write a review</a>
          </div>
        </Reveal>
      </div>

      <div className="relative mt-12">
        <div ref={trackRef} className="flex snap-x gap-6 overflow-x-auto pb-4 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
          {reviews.map((r, i) => (
            <div key={i} className="w-[88%] flex-shrink-0 snap-start rounded-[28px] bg-pawelle-bg p-8 sm:w-[46%] lg:w-[31.5%]">
              <div className="flex gap-1">
                {[0, 1, 2, 3, 4].map((k) => (
                  <Star key={k} className={`h-5 w-5 ${k < 4 ? "fill-pawelle-orange text-pawelle-orange" : "fill-pawelle-ink/15 text-pawelle-ink/15"}`} />
                ))}
              </div>
              <p className="mt-5 font-display text-[17px] font-medium leading-relaxed text-pawelle-ink">{QUOTE}</p>
              <div className="mt-6 flex items-center gap-4">
                <img src={`/pawelle/${r.img}`} alt={r.name} className="h-14 w-14 rounded-full object-cover" />
                <div>
                  <h5 className="font-display text-[17px] font-semibold text-pawelle-ink">{r.name}</h5>
                  <p className="font-body text-[14px] text-pawelle-body">{r.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-6 flex justify-center gap-3">
          <button onClick={() => scroll(-1)} className="flex h-11 w-11 items-center justify-center rounded-full border-2 border-pawelle-primary text-pawelle-primary transition hover:bg-pawelle-primary hover:text-white" aria-label="Previous">
            <ChevronLeft className="h-5 w-5" />
          </button>
          <button onClick={() => scroll(1)} className="flex h-11 w-11 items-center justify-center rounded-full bg-pawelle-primary text-white transition hover:bg-pawelle-primary-dark" aria-label="Next">
            <ChevronRight className="h-5 w-5" />
          </button>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
